// import redux
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../features/store";
import {checkListCloseAction} from "../../features/sliceReducer/interactionReducer";

//import material-UI
import {makeStyles, createStyles, Theme} from "@material-ui/core/styles";
import {Modal} from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";

import FieldCheckList from "./FieldCheckList";
import CreateFieldCheck from "./CreateFieldCheck";
import DetailFieldCheck from "./DetailFieldCheck";
import ModifyFieldCheck from "./ModifyFieldCheck";

//material-UI-Style

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  })
);

const CheckListModal = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const {checkListModalToggle, checkListSwitch} = useSelector(
    (state: RootState) => state.interaction
  );

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={checkListModalToggle}
      onClose={() => {
        dispatch(checkListCloseAction());
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={checkListModalToggle}>
        {checkListSwitch === 0 ? (
          <FieldCheckList />
        ) : checkListSwitch === 1 ? (
          <DetailFieldCheck />
        ) : checkListSwitch === 2 ? (
          <ModifyFieldCheck />
        ) : (
          <CreateFieldCheck />
        )}
      </Fade>
    </Modal>
  );
};

export default CheckListModal;
